import { Link, useNavigate } from "react-router";
import { TokenPairIcon } from "../../components/ui/token-pairIcon.tsx";
import { ManageLiquidityPool } from "./components/manage-liquidity-pool";
import { SelectToken } from "./components/select-token";
import { TokenIcon } from "../../components/ui//token-icon.tsx";
import { TradeSetting } from "./components/trade-setting.tsx";
import { Slider } from "../../components/ui/slider.tsx";
import { useCallback, useState } from "react";
import { TradeConfirm } from "./components/trade-confirm.tsx";
// import { Button } from "../../components/ui/button.tsx";
import { useParams } from 'react-router-dom'; 
import usePairToken from "../../hooks/usePairToken.js";
import userPairInfo from "../../hooks/usePairInfo.js";
import useAllowance from "../../hooks/useAllowance.js";
import useToken from "../../hooks/useToken.js";
import useRouter from "../../hooks/useRouter.js";
import { formatUnits } from "viem";
import toast from "react-hot-toast";
import TxConfirmModal from "../../components/TxConfirmModal/index.js";
import { useDisclosure } from "@nextui-org/react";
import { Button } from "@nextui-org/react";

export default function RemovePair() {
  const navigate = useNavigate();
  const [removeAmount, setRemoveAmount] = useState(0);
  const { tokenAAddress, tokenBAddress, pairAddress } = useParams();
  const { isOpen: isSubmittedOpen, onOpen: onSubmittedOpen, onOpenChange: onSubmittedOpenChange } = useDisclosure();
  // const [txHash, setTxHash] = useState(null)

  // the hook is implemented in plain JS, so cast its result to a known shape to avoid `never` inference
  const { data } = usePairToken({ tokenAAddress, tokenBAddress, pairAddress }) as { data: { tokenA: any; tokenB: any } | null };
  const tokenA = data?.tokenA;
  const tokenB = data?.tokenB;

  const { data: pairInfo ,onRemovePair,txhash:txHash,isLoading} = userPairInfo(tokenA, tokenB);
  const router = useRouter();
  const pairToken= useToken(pairAddress);
    const {
      value: allowance,
      approve,
      loading: approving
    } = useAllowance(pairToken, router)
    // console.log("allowance", allowance)
    // console.log("pairInfo", pairInfo)
      const onSwapSubmit = useCallback(() => {
        // setAmountIn('')
        // setTxHash(txHash)
        // onSwapOpenChange()
        onSubmittedOpen()
      }, [ onSubmittedOpen])
  return (
    <div className="px-[24px]">
      <div className="bg-[#1A1C1E] text-white px-[20px] py-[15px] mb-[15px] rounded-lg">
        <div className="flex items-center justify-between mb-[10px]">
          <Button
            variant={"link"}
            className="!bg-[transparent] p-0 cursor-pointer"
            onPress={() => {
              navigate("/trade", { replace: true });
            }}
          >
            <img src="/assets/icons/back.png" alt="" width={12} height={12} />
          </Button>
          {/* <Link to="/trade" className="text-[12px] font-bold">
            <img src="/assets/icons/back.png" alt="" width={12} height={12} />
          </Link> */}
          <span className="text-[12px] font-bold">去除流动资金</span>

          <TradeSetting>
            <Button
              variant={"link"}
              className="!bg-[transparent] p-0 cursor-pointer"
            >
              <img
                src="/assets/icons/setting.png"
                alt=""
                width={12}
                height={12}
              />
            </Button>
          </TradeSetting>
        </div>
        <div className="w-full py-[12px] leading-[20px] rounded-lg text-[10px] font-regular bg-[#886C24] mb-[12px] px-[23px]">
          提示：退出资金池，按照当前汇率将您的资金池份额转换回原本代币。您收到的代币数额中将包含已累计的手续费。
        </div>
        <div className="flex flex-col gap-y-[8px] items-center">
          <div className=" bg-[#2C2F33] w-full py-2 px-[10px] rounded-lg pb-[33px]">
            <div className="text-[10px] font-regular">去除数额</div>
            <div className="text-[40px] text-[#EDB52A]">{removeAmount}%</div>
            <Slider
              className="mt-[20px]
            [&>span:first-child>span]:bg-[#EDB52A]    /* 2. 填充 (Range) */
            [&>span:nth-child(2)]:border-[#EDB52A]           /* 3. 滑块 (Thumb) */
            [&>span:nth-child(2)>span]:bg-[#EDB52A]           /* 3. 滑块 (Thumb) */
          "
              value={[removeAmount]}
              onValueChange={(value) => setRemoveAmount(value[0])}
            />
            <div className="flex items-center justify-between mt-[20px] gap-x-1">
              {["25", "50", "75", "100"].map((item) => (
                <div
                  key={item}
                  className="text-[10px] font-regular bg-[#3A3F44] rounded-lg py-2 text-center border border-[#EDB52A] w-full"
                  onClick={() => setRemoveAmount(Number(item))}
                >
                  {item}%
                </div>
              ))}
            </div>
          </div>
          <img
            src="/assets/icons/arrowleftcircle左圆箭头@2x.png"
            alt=""
            width={19}
            height={19}
            className="my-[14px]"
          />
          <div className=" bg-[#2C2F33] w-full py-4 px-[10px] rounded-lg space-y-[21px]">
            <div className="flex items-center justify-between text-[10px] font-regular">
              <span>{pairInfo?.tokenABalance*removeAmount/100}</span>
              <span>{tokenA?.symbol}</span>
            </div>
            <div className="flex items-center justify-between text-[10px] font-regular">
              <span>{pairInfo?.tokenBBalance*removeAmount/100}</span>
              <span>{tokenB?.symbol}</span>
            </div>
          </div>
        </div>
        {/* <div className="px-[10px] space-y-[15px] mt-[14px]">
          <div className="flex items-center justify-between text-[10px] font-regular">
            <span>兑换率:</span>
            <span>BNB</span>
          </div>
          <div className="flex items-center justify-between text-[10px] font-regular">
            <span></span>
            <span>USDT</span>
          </div>
        </div> */}
        <div className="flex gap-x-[10px] mt-[22px]">
          {pairToken&&(<><Button className="bg-button text-white flex-1 disabled:bg-[transparent] border border-button" onPress={()=>{
            approve().finally(()=>{

            })
          }} disabled={approving || formatUnits(allowance,pairToken.decimals) > 0 } >
             {formatUnits(allowance,pairToken.decimals)  > 0 ? "已批准" : approving ? "批准中..." : "批准"}</Button>
          {/* <TradeConfirm /> */}
            <Button className="bg-button text-white flex-1" disabled={formatUnits(allowance,pairToken?.decimals)  <= 0 } onPress={()=>{
              onRemovePair(removeAmount).then(()=>{
                onSwapSubmit()
              })
              } } isLoading={isLoading} disabled={isLoading} >
              去除
            </Button>
        </>)}
        </div>
      </div>
      <div className="bg-[#1A1C1E] text-white px-[20px] py-[15px] rounded-lg">
        <div className="text-[10px] font-regular mb-[15px]">
          您的流动资金仓位
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <TokenPairIcon tokens={[tokenA, tokenB]} className="mr-[10px]" />
            <span className="text-[10px] font-regular">/</span>
          </div>
          <span className="text-[10px] font-regular">{pairInfo?.userBalance}</span>
        </div>
        <div className="space-y-[13px] mt-[22px]">
          <div className="text-[10px] font-regular flex justify-between">
            <span>您的流动池份额:</span>
            <span>{pairInfo?.percent}%</span>
          </div>
          <div className="text-[10px] font-regular flex justify-between">
            <span>{tokenA?.symbol}:</span>
            <span>{pairInfo?.tokenABalance}</span>
          </div>
          <div className="text-[10px] font-regular flex justify-between">
            <span>{tokenB?.symbol}:</span>
            <span>{pairInfo?.tokenBBalance}</span>
          </div>
        </div>
      </div>
            <TxConfirmModal
              hash={txHash}
              isOpen={isSubmittedOpen}
              onOpenChange={onSubmittedOpenChange}
            />
    </div>
  );
}
